import axios from './AxiosHost';
// import _ from 'lodash';
// import debounce from 'lodash/debounce';

export default class Logic {
    constructor(init = null){
        this.init = init;
    }

    validateDate(str){
        const minYear = 1900;
        const maxYear = new Date().getFullYear();
        const delimiter = '/';

        let parts = str.split(delimiter).map(item => {return parseInt(item)});
        
        if(parts.length === 3 && !isNaN(parts[0]) && !isNaN(parts[1]) && !isNaN(parts[2])){
            let day = parts[0];
            let month = parts[1];
            let year = parts[2];
            let maxDaysInMonth = 0;
            
            switch(month){
                case 1:
                    maxDaysInMonth = 31;
                    break;
                case 2:
                    maxDaysInMonth = 28;
                    break;
                case 3:
                    maxDaysInMonth = 31;
                    break;
                case 4:
                    maxDaysInMonth = 30;
                    break;
                case 5:
                    maxDaysInMonth = 31;
                    break;
                case 6:
                    maxDaysInMonth = 30;
                    break;
                case 7:
                    maxDaysInMonth = 31;
                    break;
                case 8:
                    maxDaysInMonth = 31;
                    break;
                case 9:
                    maxDaysInMonth = 30;
                    break;
                case 10:
                    maxDaysInMonth = 31;
                    break;
                case 11:
                    maxDaysInMonth = 30;
                    break;
                case 12:
                    maxDaysInMonth = 31;
                    break;
                default:
                    maxDaysInMonth = 30;
                    break;
            }

            if(year >= minYear && year <= maxYear && day <= maxDaysInMonth && day > 0 && month > 0 && month < 13 ) {
                return true;
            }
        }
        return false
    }

    formatDate(d){
        let date = new Date(d);
        return this.pad(date.getDate().toString(), 2, '0') + '/' + this.pad((date.getMonth() + 1).toString(), 2, '0') + '/' + date.getFullYear();
    }

    getBaseRedirectUrl(){
        let baseURL = window.location.hostname === 'localhost' ? 'http://localhost:3000/' : process.env.PUBLIC_URL + '/index.html';
        return baseURL;
    }

    getApiBaseUrl(){
        let baseURL = window.location.hostname === 'localhost' ? 'http://apps/ReliabilityCheck' : process.env.PUBLIC_URL;
        return baseURL;
    }

    getDownloadFilledFormsUrl(authKey){
        let res = this.getApiBaseUrl() + '/Attachment/DownloadFilledForms?authKey=' + authKey;
        return res;
    }

    log(message){
        if(this.init && this.init.verbose){
            console.log(message);
        }else{
            console.log(message);
        }
    }

    trimObjectFields(obj){
        if(obj){
            for(var field in obj){
                if(typeof(obj[field]) === 'string'){
                    obj[field] = obj[field].trim();
                }else if(typeof(obj[field]) === 'object' && obj[field].constructor.name !== 'Date'){
                    this.trimObjectFields(obj[field]); //recursion
                }
            }
        }
    }

    getQueryStringParam(name){
        var result = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if(result === null){
            return null;
        }else{
            return decodeURI(result[1] || 0);
        }
    }

    checkForAuthenticationError(res){
        //handle redirects which caused by authenticated filter, in case that candidate sms cert expired 
        if(res.status === 302){
            window.open(res.url);
        }

        //handle case that server responded with empty init from the auth controller, which is unprotected by authenticated filter
        if(res.data.message){
            if(res.data.messge === 'UnAuthenticatedCandidate'){
                window.open(process.env.PUBLIC_URL + '#/login');
            }else if(res.data.messge === 'Unknown'){
                window.open(process.env.PUBLIC_URL + '#/error');
            }
        }
    }

    async getData(url, success) {
        try{
            var res = await axios.get(url);
            this.log(res.data);
            this.checkForAuthenticationError(res);
            success(res.data);
        }catch(error){
            
        }
    }

    async postData (url, data, onSuccess) {
        try{
            var res = await axios.post(url, data);

            console.log('ERROR');
            console.log(res);
            this.log(res.data);
            this.checkForAuthenticationError(res)

            if(onSuccess && res.data.success){
                onSuccess(res.data);
            }

            if(res.error || !res.data.success){
                alert(`אירעה שגיאה ${res.message}`);
            }

            return res;
        }catch(error){
            console.log(JSON.parse(JSON.stringify(error)));
            alert(`אירעה שגיאה ${error.response.data.ExceptionMessage}`);
        }
    }

    cancelCandidate(candidate, callback){
        return this.postData('User/Cancel', candidate, callback);
    }

    extendCandidate(candidate, callback){
        return this.postData('User/Extend', candidate, callback);
    }

    confirmCandidate(candidate, callback){
        return this.postData('User/Confirm', candidate, callback);
    }

    reInviteCandidate(candidate, callback){
        return this.postData('User/ReInvite', candidate, callback);
    }

    getCandidateByAuthKey(authKey, callback){
        return this.getData('User/GetCandidateByAuthKey?authKey=' + authKey, callback);
    }

    validateSms(identityNumber, mobilePhone, smsCode, callback){
        let payload = {
            identityNumber: identityNumber,
            mobilePhone: mobilePhone,
            smsCode: smsCode,
            authKey: this.getAuthKey() //this.getQueryStringParam('authKey')
        }
        return this.postData('Auth/ValidateSms', payload, callback);
    }

    sendAuthentioncationSms(identityNumber, mobilePhone, callback){
        let payload = {
            identityNumber: identityNumber,
            mobilePhone: mobilePhone,
            smsCode: null,
            authKey: this.getAuthKey() //this.getQueryStringParam('authKey')
        }
        return this.postData('Auth/SendAuthentioncationSms', payload, callback);
    }

    validateIdentityNumber(number){
        //http://halemo.net/info/idcard/
        number = this.pad(number, 9, 0);
        let weights = '121212121';
        let multiples = [];
        for(let i = 0; i < number.length; i++){
            multiples.push(parseInt(number[i]) * parseInt(weights[i]) > 9 ? 
                            parseInt((parseInt(number[i]) * parseInt(weights[i])).toString()[0]) + parseInt((parseInt(number[i]) * parseInt(weights[i])).toString()[1]) : 
                            (parseInt(number[i]) * parseInt(weights[i]))
                        );
        }
        return multiples.reduce((total, number) => { return total + number }) % 10 === 0 && number !== '000000000';
    }

    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    getAuthKey(){
        let queryStringAuthKey = this.getQueryStringParam('authKey');
        let sessionStorageAuthKey = sessionStorage.getItem('authKey');
        return sessionStorageAuthKey || queryStringAuthKey;
    }

    getInit (callback) {
        let queryStringAuthKey = this.getQueryStringParam('authKey');
        let sessionStorageAuthKey = sessionStorage.getItem('authKey');
        let authKey = sessionStorageAuthKey || queryStringAuthKey;

        //prevent situation when refreshing page querystring is lost and thus null is stored
        if(sessionStorageAuthKey){
            sessionStorage.setItem('authKey', queryStringAuthKey);
        }
        
        return this.getData(authKey ? 'Auth/Authenticate?authKey=' + authKey : 'Auth/Authenticate?authKey=', callback);
    }

    getTablePage (action, pageNumber, pageRows, query, callback){
        return this.getData(action + '?pageNumber=' + pageNumber + '&pageSize=' + pageRows + (query !== null ? '&query=' + encodeURI(query) : ''), callback);
    }

    async validatePersonalDetailsForm(values, step, userId, candidateId){
        let payload = {
            candidateId:candidateId,
            step:step,
            userId:userId,
            candidate:values
        };
        let res = await axios.post('Form/Validate', payload);
        return res;
    }

    async createCandidate (form, callback){
        let res = await this.postData('User/CreateCandidate', form, callback);
        return res.data;
    }

    padDate(str){
        return str.split('/').map(a => {return this.pad(a, 2, '0')}).join('/');
    }

    async saveForm (form, step, callback){
        if(form.birthDate && form.birthDate.length !== 10){
            form.birthDate = form.birthDate.split('/').map(a => {return this.pad(a, 2, '0')}).join('/');
        }

        if(form.aliyaDate && form.aliyaDate.length !== 10){
            form.aliyaDate = form.aliyaDate.split('/').map(a => {return this.pad(a, 2, '0')}).join('/');
        }

        let res = await this.postData('Form/SaveCandidate?step=' + step, form, callback);
        return res.data;
    }

    async uploadFile (init, file, type, callback) { //pass list of files since it can be multiple e.target.files[0]
        // let token = await axios.get(init.uploadTokenUrl, init.uploadAppId);

        const formData = new FormData();
        formData.append('type',type);
        formData.append('file',file);

        const config ={header: {'content-type': 'multipart/form-data'}};
        var res = await axios.post(init.uploadFileUrl, file, config);
        callback(res);
        return res;
    }

   

    saveSignature (candidateId, signature, callback){
        let payload = {
            candidateId: candidateId,
            signature: signature
        }
        return this.postData('Form/SaveSignature', payload, callback);
    }

    getAutocomplete (api, parentId, query, callback){
        return this.getData('Form/' + api + '?parentId=' + parentId +'&query=' + encodeURI(query.trim()), callback);
    }

    //*************************************************
    //used in the vendor component which is irrelevant
    //*************************************************
    getAllVendors(callback){
        return this.getData('Admin/GetAllVendors', callback);
    }

    //*****************
    //Admin only action
    //*****************
    // getAllUsers(callback){
    //     return this.getData('Admin/GetAllUsers', callback);
    // }

    getVendors(query, callback){
        return this.getData('Admin/GetVendors?query=' + encodeURI(query.trim()), callback);
    }

    saveUser(id, position, requestorType, identityNumber, firstName, lastName, email, phone, vendors, liaison, callback){
        let payload = {
            id: id,
            position: position,
            requestorType: requestorType,
            firstName: firstName,
            lastName: lastName,
            identityNumber: identityNumber, 
            email: email, 
            phone: phone, 
            vendors: vendors,
            liaison: liaison
        };

        return this.postData('Admin/SaveUser', payload, callback);
    }

    deleteUser(user, callback){
        return this.postData('Admin/DeleteUser', user, callback);
    }
}